import { useStore } from "vuex";

export default defineNuxtRouteMiddleware(async (to, from) => {
	const store = useStore();
	const segment = store.state.siteSegment;

	if (!store.state.globals[segment].header) {
		const { data: globals } = await useFetch(`/api/content/globals/${segment}`);
		store.commit("setGlobals", { segment, globals });
	}
});
